/* eslint-disable no-console */
import { hasAssets } from './account-api';

const showNewNavIndicator = (status) => {
  const icon = document.querySelector('header .icon-item-my-account');
  if (icon === null) {
    return;
  }
  const visibleClass = 'items-added-to-account';
  if (!status) {
    icon.classList.remove(visibleClass);
  } else {
    icon.classList.add(visibleClass);
  }
};

const showNavIndicator = (status) => {
  const icon = document.getElementById('swbk-plus');
  // if element doesn't exist, use new nav indicator
  if (icon === null) {
    showNewNavIndicator(status);
    return;
  }
  const visibleClass = 'is-visible';
  const growClass = 'is-grow';

  if (!status) {
    icon.classList.remove(visibleClass);
    return;
  }
  if (icon.classList.toString().indexOf(visibleClass) !== -1) {
    icon.classList.add(growClass);
    setTimeout(() => {
      icon.classList.remove(growClass);
    }, 200);
  } else {
    icon.classList.add(visibleClass);
  }
};

const updateAccountStatusMessage = (assetType, action) => {
  const msgDiv = document.querySelector('.my-account-status-message');
  if (!window.isAuthenticated || !msgDiv) {
    return;
  }
  // Clear existing message
  msgDiv.innerHTML = '';
  setTimeout(() => {
    if (action === 'add') {
      msgDiv.innerHTML = `${assetType} has been added to your favorites.`;
    }
    if (action === 'remove') {
      msgDiv.innerHTML = `${assetType} has been removed from your favorites.`;
    }
  }, 100);
};

const updateSwatchCartStatusMessage = (action) => {
  const msgDiv = document.querySelector('.my-account-status-message');
  if (!msgDiv) {
    return;
  }
  // Clear existing message
  msgDiv.innerHTML = '';
  setTimeout(() => {
    if (action === 'add') {
      msgDiv.innerHTML = 'Swatch has been added to your swatch cart.';
    }
    if (action === 'remove') {
      msgDiv.innerHTML = 'Swatch has been removed from your swatch cart.';
    }
  }, 100);
};

const updateAccountIconStatus = () => {
  if (!window.isAuthenticated) {
    return;
  }
  hasAssets((data) => {
    if (data['has-assets']) {
      showNavIndicator(true);
    } else {
      showNavIndicator(false);
    }
  });
};

export {
  updateAccountIconStatus,
  updateAccountStatusMessage,
  updateSwatchCartStatusMessage,
};
/* eslint-enable no-console */
